import { useCryptoWidgetVariant } from 'hooks/useCryptoWidgetVariant';

import { TableLayout } from 'components/ui/templates/TableLayout/TableLayout';

import { CryptoFundingContent } from './CryptoFundingContent';
import { CryptoFundingHeader } from './CryptoFundingHeader';

import { Loading } from '../Loading';

export const CryptoFunding = () => {
  const { cryptoWidgetVariant, isLoading } = useCryptoWidgetVariant();

  return (
    <TableLayout
      header={<CryptoFundingHeader />}
      content={
        isLoading ? (
          <Loading className="!h-20" />
        ) : (
          <CryptoFundingContent variant={cryptoWidgetVariant} />
        )
      }
    />
  );
};
